import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./ProductCard.css";

import ProductRating from "./ProductRating";
import { formatPKR } from "../helpers/utils";
import { useCartWishlist } from "../context/CartWishlistContext";
import React from "react";

const ProductCard = ({
  viewProduct,
  product = {},
  viewMode = false,
  // addItemtoCart,
  // removeItemtoCart,
  // cartList,
  // addItemtoWishlist,
  // removeItemtoWishlist,
  // wishList = [],
  index,
}) => {
  console.log(product);

  // const isProductInCart = () => {
  //   return cartList.some((v) => v.product._id === product._id);
  // };

  // const isProductInWishlist = () => {
  //   return wishList.some((v) => v.product._id === product._id);
  // };

  const {
    isInCart,
    addItemtoCart,
    removeItemtoCart,
    isInWishlist,
    addItemtoWishlist,
    removeItemtoWishlist,
  } = useCartWishlist();

  // track loading for each image
  const [loaded, setLoaded] = React.useState({});

  const handleImageLoad = (index) => {
    setLoaded((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <div className="bb-deal-card product-card">
      <div className="bb-pro-box">
        <div className="bb-pro-img">
          {/* Badge */}
          {product.isNewItem && (
            <span className="flags">
              <span>New</span>
            </span>
          )}

          {/* Product Image */}
          <a
            onClick={(e) => {
              e.preventDefault();
              viewProduct(product);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="inner-img text-center">
              {!loaded[index] && (
                <div className="img-loader">
                  <div className="spinner"></div>
                </div>
              )}
              <img
                // className="main-img"
                className={`main-img ${loaded[index] ? "visible" : "hidden"}`}
                src={product.imageUrl || "/img/product/1.jpg"}
                alt={`Product ${index + 1}`}
                onLoad={() => handleImageLoad(index)}
                onError={() => handleImageLoad(index)}
                loading="lazy"
              />
            </div>
          </a>

          {/* Action Buttons */}
          {!viewMode && (
            <ul className="bb-pro-actions">
              <li className="bb-btn-group">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-wishlist">Wishlist</Tooltip>}
                >
                  <a
                    href="#!"
                    onClick={() =>
                      isInWishlist(product._id)
                        ? removeItemtoWishlist(product._id)
                        : addItemtoWishlist(product._id)
                    }
                    title="Wishlist"
                  >
                    {isInWishlist(product._id) ? (
                      <i className="bi bi-heart-fill text-danger"></i>
                    ) : (
                      <i className="bi bi-heart"></i>
                    )}
                  </a>
                </OverlayTrigger>
              </li>

              <li className="bb-btn-group">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-quickview">Quick View</Tooltip>}
                >
                  <a
                    href="#!"
                    onClick={() => viewProduct(product)}
                    title="Quick View"
                  >
                    <i className="bi bi-eye" />
                  </a>
                </OverlayTrigger>
              </li>

              <li className="bb-btn-group">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-addtocart">
                      {isInCart(product._id)
                        ? "Remove from Cart"
                        : "Add to Cart"}
                    </Tooltip>
                  }
                >
                  <a
                    href="#!"
                    onClick={() =>
                      isInCart(product._id)
                        ? removeItemtoCart(product._id)
                        : addItemtoCart(product._id)
                    }
                    title="Add To Cart"
                  >
                    {isInCart(product._id) ? (
                      <i className="bi bi-cart-fill text-success" />
                    ) : (
                      <i className="bi bi-cart" />
                    )}
                  </a>
                </OverlayTrigger>
              </li>
            </ul>
          )}
        </div>
        <div className="bb-pro-contact">
          <div className="bb-pro-subtitle">
            {product.brand ? (
              <a href="#!" style={{ textDecoration: "none" }}>
                {product.brand}
              </a>
            ) : (
              <a href="#!">Chocos</a>
            )}
            <ProductRating rating={product.rating} />
          </div>
          <h4 className="bb-pro-title">
            <a href="#!" style={{ textDecoration: "none" }}>
              {product.title}
            </a>
          </h4>
          <div className="bb-price">
            <div className="inner-price">
              <span className="new-price">{formatPKR(product.price)}</span>
              <span className="old-price">
                {formatPKR(product.originalPrice)}
              </span>
            </div>
            <span className="last-items">{product.packSize} Pack</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
